/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeEvent,
  ComputeEvent$inboundSchema,
  ComputeEvent$Outbound,
  ComputeEvent$outboundSchema,
} from "./computeevent.js";

export type ComputeEventList = {
  nextCursor: string | null;
  total: number;
  data: Array<ComputeEvent>;
};

/** @internal */
export const ComputeEventList$inboundSchema: z.ZodType<
  ComputeEventList,
  z.ZodTypeDef,
  unknown
> = z.object({
  next_cursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeEvent$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "next_cursor": "nextCursor",
  });
});
/** @internal */
export type ComputeEventList$Outbound = {
  next_cursor: string | null;
  total: number;
  data: Array<ComputeEvent$Outbound>;
};

/** @internal */
export const ComputeEventList$outboundSchema: z.ZodType<
  ComputeEventList$Outbound,
  z.ZodTypeDef,
  ComputeEventList
> = z.object({
  nextCursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeEvent$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    nextCursor: "next_cursor",
  });
});

export function computeEventListToJSON(
  computeEventList: ComputeEventList,
): string {
  return JSON.stringify(
    ComputeEventList$outboundSchema.parse(computeEventList),
  );
}
export function computeEventListFromJSON(
  jsonString: string,
): SafeParseResult<ComputeEventList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeEventList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeEventList' from JSON`,
  );
}
